module.exports = __webpack_public_path__ + "static/media/Spices-stall-India_tablet.463035df.jpg";